import {Button, Col, Flex, Row} from "antd";
import {EyeOutlined, UserOutlined, PhoneOutlined, LogoutOutlined} from "@ant-design/icons";
import React from "react";
import {useNavigate} from 'react-router-dom';
import {PageContainer} from "@/components/PageContainer/PageContainer";
import {useStore} from "@/store/useStore";
import {getRootPageRoute} from "@/routes/routes";
import {appConfiguration} from "@/setup";
import {useAuth} from "@/provider/auth/useAuth";

export const HeaderTop = (props: any) => {
    const navigate = useNavigate();
    const {isAuthenticated, logout} = useAuth();
    const {isMobile, isTablet, changeTheme, useIncreasedContrastTheme, showLoginOrRegistrationModal} = useStore();

    const exitHandler = () => {
        logout();
        navigate(getRootPageRoute(), { replace: true });
    }
    
    return (
        <PageContainer height={`78px`} mainBackgroundColor={`var(--main-color-white)`}>
            <Row align="middle" justify="space-between" style={{backgroundColor: `var(--main-color-white)`}}>
                <Col>
                    <Button 
                        icon={<PhoneOutlined />}
                        href={`tel:${appConfiguration.hotline}`}
                        style={{
                            border: `var(--main-color-white)`, 
                            color: `var(--main-color-white)`, 
                            backgroundColor: useIncreasedContrastTheme ? `#00000070` : `var(--main-color-dark-gold)`
                        }}
                    >{appConfiguration.hotline}</Button>
                    {!isMobile && <span style={{color: `var(--main-color-black)`}}> - гаряча лінія з питань евакуації</span>}
                </Col>
                <Col>
                    <Flex gap={20}>
                        <Button 
                            icon={<EyeOutlined />} 
                            onClick={changeTheme} 
                            style={{minWidth: "50px"}}>
                            {!isMobile && !isTablet && "Налаштування доступності"}
                        </Button>
                        {/*{isAuthenticated */}
                        {/*    ? <Button*/}
                        {/*        type="primary"*/}
                        {/*        icon={<LogoutOutlined />}*/}
                        {/*        onClick={() => exitHandler()}*/}
                        {/*        style={{ color: `var(--main-color-white)`, minWidth: "50px"}}*/}
                        {/*    >*/}
                        {/*        {!isMobile && !isTablet && "Вихід"}*/}
                        {/*    </Button>*/}
                        {/*    : <Button*/}
                        {/*        type="primary"*/}
                        {/*        icon={<UserOutlined />}*/}
                        {/*        onClick={() => showLoginOrRegistrationModal(true)}*/}
                        {/*        style={{ color: `var(--main-color-white)`, minWidth: "50px"}}*/}
                        {/*    >*/}
                        {/*        {!isMobile && !isTablet && "Особистий кабінет"}*/}
                        {/*    </Button>*/}
                        {/*}*/}
                    </Flex>
                </Col>
            </Row>
        </PageContainer>
    )
}